import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorHandler } from '@angular/core';
import { RequestOptions } from '@angular/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatOptionModule,
    MatSelectModule, MatToolbarModule, MatCardModule, MatDatepickerModule,
    MatNativeDateModule, MatTabsModule, MatExpansionModule, MatDividerModule,
    MatMenuModule, MatTableModule, MatPaginatorModule, MatButtonToggleModule,
    MatIconModule, MatProgressBarModule, MatDialogModule, MatSnackBarModule, MatInputModule } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ChartsModule } from 'ng2-charts';
import { MomentModule } from 'angular2-moment';

/**** Common Filters  */
import { FilterNwtype } from './filter.nwtype';
import { FilterNwamounts } from './filter.nwamounts';
import { FilterTotalIncomeLeft } from './filter.totalincomeleft';
import { FilterCompletedgoals } from './filter.completedgoals';

/**** GUARDS & AUTH/ERROR  */
import { AuthGuard } from './auth.guard';
import { RoleGuard } from './role.guard';
import { AuthRequestOptions } from './auth-request';
import { AuthErrorHandler } from './error-handler';


@NgModule({
  imports: [
      CommonModule
  ],
  declarations: [
    FilterNwtype,
    FilterNwamounts,
    FilterTotalIncomeLeft,
    FilterCompletedgoals,
  ],
  exports: [
        FilterNwtype,
        FilterNwamounts,
        FilterTotalIncomeLeft,
        FilterCompletedgoals,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        HttpClientModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatToolbarModule,
        MatCardModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatExpansionModule,
        MatDividerModule,
        MatMenuModule,
        MatTableModule,
        MatPaginatorModule,
        MatButtonToggleModule,
        MatIconModule,
        MatProgressBarModule,
        MatDialogModule,
        FlexLayoutModule,
        CurrencyMaskModule,
        ChartsModule,
        MatSnackBarModule,
        MomentModule
    ],
        providers: [
            AuthGuard,
            RoleGuard,
            {
              provide: RequestOptions,
              useClass: AuthRequestOptions
            },
            {
              provide: ErrorHandler,
              useClass: AuthErrorHandler,
            }]
})
export class AppCommonModule { }



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/app-common.module.ts